module.exports = __webpack_public_path__ + "img/logo.b72c80a6.png";